export default __webpack_public_path__ + "static/media/LEFT-P14-3-2mm.a93f94f2.dwg";